import { judgeIsMobile } from '@/utils'
export default {
  namespaced: true,
  state: {
    pages: [],
    currentPage: [0, 1],
    bookPath: '',
    totalPage: 0,
    showTotalPage: 0,
    isMobile: judgeIsMobile(),
    isBigScreen: false,
    play: true, // 播放音频
    isZoom: false,
    start: 1,
    currentZoom: 1,
    translate: {
      oldX: 0,
      oldY: 0
    },
    isPaper: false, //是否为数字报
    readModel: 0, //是否为数字报
    isShowTitle: true, //是否显示book-title
    isShowFooter: true, //是否显示book-footer
    isShowCommerHeader: true,
    isShowHelp: false, //是否显示pc端help组件提示框
    isShowPhoneHelp: false, //移动端
    timer: null,
    isLock: false, // 是否锁定上下导航栏
    positionList: [], //关键字位置信息
    isShowYellow: true, //标黄位置是否展示
    goPage: '',
    yellow: null,
    bookData: null, //单本书的数据
    isShowDigitalArticleMenu: false, //是否显示文章目录
    isShowDigitalArticleView: false, //是否显示文章内容
    digitalArticleId: 0, //当前小样id
    isShowStreamTip: false, //是否显示pc端流式阅读只是
    isShowPhoneStreamTip: false, //移动端
    isShowWindow: 1, //搜索关键字、目录、查看往期,缩略图，播放控制对应1，2，3,4,5
    batchPDFFiles: null, //合并、批量上传临时文件
    isBook: null, // 是否为电子书刊
    classifyManage: '',
    bookCatalogList: []
  },
  mutations: {
    UPDATE_IS_SHOW_DIGITAL_ARTICLE_MENU(state, isShowDigitalArticleMenu) {
      state.isShowDigitalArticleMenu = isShowDigitalArticleMenu
    },
    UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW(state, isShowDigitalArticleView) {
      state.isShowDigitalArticleView = isShowDigitalArticleView
    },
    DIGITAL_ARTICLE_ID(state, digitalArticleId) {
      state.digitalArticleId = digitalArticleId
    },
    UPDATE_IS_LOCK(state, isLock) {
      state.isLock = isLock
    },
    UPDATE_IS_PAPER(state, isPaper) {
      state.isPaper = isPaper
    },
    //是否显示头部的方法
    UPDATE_IS_SHOW_TITLE(state, isShowTitle) {
      if (state.isLock && state.isMobile) {
        state.isShowTitle = true
      } else {
        state.isShowTitle = isShowTitle
      }
    },
    //是否显示脚部的方法
    UPDATE_IS_SHOW_FOOTER(state, isShowFooter) {
      if (state.isLock && state.isMobile) {
        state.isShowFooter = true
      } else {
        state.isShowFooter = isShowFooter
      }
    },
    UPDATE_TIMER(state, timer) {
      state.timer = timer
    },
    // 提示框是否出现
    UPDATE_IS_SHOW_Help(state, isShowHelp) {
      state.isShowHelp = isShowHelp
    },
    UPDATE_IS_SHOW_PHONE_Help(state, isShowPhoneHelp) {
      state.isShowPhoneHelp = isShowPhoneHelp
    },
    // 提示框流式阅读
    UPDATE_IS_SHOW_STREAM_TIP(state, isShowStreamTip) {
      state.isShowStreamTip = isShowStreamTip
    },
    UPDATE_IS_SHOW_PHONE_STREAM_TIP(state, isShowPhoneStreamTip) {
      state.isShowPhoneStreamTip = isShowPhoneStreamTip
    },
    //是否显示公共头部
    UPDATE_IS_SHOW_COMMERHEADER(state, isShowCommerHeader) {
      state.isShowCommerHeader = isShowCommerHeader
    },
    UPDATE_TOTAL_PAGE(state, totalPage) {
      state.totalPage = totalPage
    },
    SHOW_UPDATE_TOTAL_PAGE(state, totalPage) {
      state.showTotalPage = totalPage
    },
    UPDATE_PAGES(state, pages) {
      state.pages = pages
    },
    UPDATE_CURRENT_PAGE(state, currentPage) {
      state.currentPage = currentPage
    },
    UPDATE_IS_MOBILE(state, isMobile) {
      state.isMobile = isMobile
    },
    UPDATE_READ_MODEL(state, readModel) {
      state.readModel = readModel
    },
    UPDATE_IS_BIG_SCREEN(state, isBigScreen) {
      state.isBigScreen = isBigScreen
    },
    UPDATE_BOOK_PATH(state, path) {
      state.bookPath = path
    },
    UPDATE_PLAY(state, play) {
      state.play = play
    },
    UPDATE_IS_ZOOM(state, isZoom) {
      state.isZoom = isZoom
    },
    UPDATE_START(state, palyed) {
      state.start = palyed
    },
    UPDATE_TRANSLATE(state, palyed) {
      state.translate.oldX = palyed.oldX
      state.translate.oldY = palyed.oldY
    },
    UPDATE_ZOOM(state, palyed) {
      state.currentZoom = palyed
    },
    UPDATE_POSITIONLIST(state, positionList) {
      state.positionList = positionList
    },
    UPDATE_ISSHOWYELLOW(state, isShowYellow) {
      state.isShowYellow = isShowYellow
    },
    UPDATE_GOPAGE(state, goPage) {
      state.goPage = goPage
    },
    UPDATE_YELLOW(state, yellow) {
      state.yellow = yellow
    },
    UPDATE_BOOK_DATA(state, data) {
      state.bookData = data
    },
    UPDATE_ISSHOWWINDOW(state, data) {
      state.isShowWindow = data
    },
    UPDATE_BATCH_FILES(state, data) {
      state.batchPDFFiles = data
    },
    UPDATE_IS_BOOK(state, isBook) {
      state.isBook = isBook
    },
    UPDATE_CLASSIFY(state, classifyManage) {
      state.classifyManage = classifyManage
    },
    UPDATE_BOOK_CATALOG_LIST(state, bookCatalogList) {
      state.bookCatalogList = bookCatalogList
    }
  },
  getters: {
    // 缩略图使用页码数组
    pagesForPc({ pages }) {
      const ret = []
      pages.forEach((item, index) => {
        const pageNum = index + 1
        // 首页和偶数的末页，是单页
        if (pageNum === 1 || (pageNum === pages.length && !(pageNum % 2))) {
          ret.push({ name: `${pageNum}`, imgUrl: [item.url] })
        } else {
          // 其余情况是双页
          if (!(pageNum % 2)) {
            ret.push({ name: `${pageNum} - ${pageNum + 1}`, imgUrl: [item.url, pages[pageNum].url] })
          }
        }
      })
      return ret
    },
    pagesForTradition({ pages }) {
      const ret = []
      pages.forEach((item, index) => {
        const pageNum = index + 1
        ret.push({ name: `${pageNum}`, imgUrl: [item.url] })
      })
      return ret
    }
  }
}
